
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const testimonials = [
  {
    quote:
      "Trainings of Dereja empowered me to overcome my fear of failure, rise quickly, and build a strong professional CV. I’m grateful to  Dereja for this transformative journey!",
    name: "Simon Tefera",
    title: "Zemen Bank - Customer service officer",
  },
  {
    quote:
      "Dereja, gave me skills that made me stand out in interviews and job fairs. Don’t miss this chance to boost your potential!",
    name: "Biruk Eguale ",
    title: "Kuriftu Resort and Spa - Quality Control",
  },
  {
    quote: "Dereja trainings and internship program built my skills, confidence, and experience shaping my personal and professional growth.",
    name: "Bamlak Ejgu",
    title: "SLT Solution - Tele Marketer",
  },
  {
    quote: "Dereja  transformed me through DAAP training, it built my confidence, jump-started my career, and gave me skills I still use today. ",
    name: "Dagmawi Abebe",
    title: "Helshora Agro Industry - Finance ",
  },
];

const TestimonialSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 2) % testimonials.length);
    }, 6000); // every 6 seconds
    return () => clearInterval(interval);
  }, []);

  const currentTestimonials = [
    testimonials[index],
    testimonials[(index + 1) % testimonials.length],
  ];

  const fadeMotion = (fromLeft = true) => ({
    initial: {
      opacity: 0,
      x: fromLeft ? -20 : 20,
      y: fromLeft ? 20 : -20,
      scale: 0.98,
    },
    animate: {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
    },
    exit: {
      opacity: 0,
      x: fromLeft ? -20 : 20,
      y: fromLeft ? -20 : 20,
      scale: 0.98,
    },
  });

  return (
    <section className="bg-gray-100 py-12 px-4 md:px-20 overflow-hidden">
      <motion.h2
        className="text-3xl font-bold text-[#F36F21] mb-4 mt-8 text-center"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Youth Voices
      </motion.h2>

      <hr
        className="w-1/6 mx-auto mb-10"
        style={{
          border: "none",
          borderTop: "2px dashed",
          borderImage: "linear-gradient(to right, #ffffff, #F36F21) 1",
        }}
      />

      <div className="grid md:grid-cols-2 gap-10 items-start">
        {/* Static left content */}
        <div>
          <h3 className="text-orange-500 text-lg font-semibold border-l-4 border-orange-500 pl-2 mb-2">
            What People Say
          </h3>
          <h2 className="text-4xl font-bold text-black">About Dereja</h2>
        </div>

        {/* Top-right testimonial */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentTestimonials[0].name}
            variants={fadeMotion(false)}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 1, ease: "easeInOut" }}
            className="relative bg-[#FFBD73] text-gray-800 p-6 rounded-lg shadow-md"
          >
            <p>{currentTestimonials[0].quote}</p>
            <FormatQuoteIcon className="text-red-900 text-5xl absolute bottom-4 right-4" />
            <div className="mt-6">
              <p className="font-bold">{currentTestimonials[0].name}</p>
              <p className="text-sm text-gray-700">{currentTestimonials[0].title}</p>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Bottom-left diagonal testimonial */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentTestimonials[1].name}
            variants={fadeMotion(true)}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 1, ease: "easeInOut" }}
            className="relative bg-[#FFBD73] text-gray-800 p-6 rounded-lg shadow-md col-span-1 md:col-start-1"
          >
            <p>{currentTestimonials[1].quote}</p>
            <FormatQuoteIcon className="text-red-900 text-5xl absolute bottom-4 right-4" />
            <div className="mt-6">
              <p className="font-bold">{currentTestimonials[1].name}</p>
              <p className="text-sm text-gray-700">{currentTestimonials[1].title}</p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default TestimonialSection;
